"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("react");
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var defaultDimensions = {
  x: 0,
  y: 0,
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  width: 0,
  height: 0,
  scrollHeight: 0,
  scrollWidth: 0,
  clientHeight: 0,
  clientWidth: 0
};
var getDimensions = function getDimensions(node) {
  var rect = node.getBoundingClientRect();
  var clientWidth = node.clientWidth,
    clientHeight = node.clientHeight,
    scrollWidth = node.scrollWidth,
    scrollHeight = node.scrollHeight;
  if (rect.toJSON) {
    return __assign({
      clientHeight: clientHeight,
      clientWidth: clientWidth,
      scrollWidth: scrollWidth,
      scrollHeight: scrollHeight
    }, rect.toJSON());
  }
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top || rect.x,
    left: rect.left || rect.left,
    x: rect.x || rect.left,
    y: rect.y || rect.top,
    right: rect.right,
    bottom: rect.bottom,
    clientHeight: clientHeight,
    clientWidth: clientWidth,
    scrollWidth: scrollWidth,
    scrollHeight: scrollHeight
  };
};
function useDimensions(props) {
  if (props === void 0) {
    props = {};
  }
  var _a = __read((0, react_1.useState)(null), 2),
    node = _a[0],
    setNode = _a[1];
  var _b = __read((0, react_1.useState)(defaultDimensions), 2),
    dimensions = _b[0],
    setDimensions = _b[1];
  var _c = props.clientWidthMinDefaultValue,
    clientWidthMinDefaultValue = _c === void 0 ? 960 : _c,
    _d = props.clientWidthMaxDefaultValue,
    clientWidthMaxDefaultValue = _d === void 0 ? 1152 : _d;
  var ref = (0, react_1.useCallback)(function (newNode) {
    setNode(newNode);
  }, []);
  (0, react_1.useLayoutEffect)(function () {
    if (!node) return;
    var dimensionsObject = getDimensions(node);
    var clientWidth = document.documentElement.clientWidth;
    // 特殊逻辑, 适配 1366 分辨率
    // windows电脑下低版本chrome浏览器滚动条占位6px, 左侧导航栏响应式 mediaquery 里是按页面总宽的
    // 在 1366 页面总宽时, 依旧有左侧导航栏, 所以1366 分辨率电脑 body 宽度需要减去 6px
    if (clientWidth) {
      if (clientWidth < 1914) {
        dimensionsObject.width = clientWidthMinDefaultValue;
      } else {
        dimensionsObject.width = clientWidthMaxDefaultValue;
      }
    }
    setDimensions(dimensionsObject);
    // Observe resizing of element
    var resizeObserver = new resize_observer_polyfill_1["default"](function () {
      setDimensions(getDimensions(node));
    });
    resizeObserver.observe(node);
    return function () {
      resizeObserver.disconnect();
    };
  }, [clientWidthMaxDefaultValue, clientWidthMinDefaultValue, node]);
  return [ref, dimensions, node];
}
exports["default"] = useDimensions;